// Structured Data Schemas for SEO

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "AutoRepair",
  "name": "Carguroo Mobile Mechanics",
  "description": "Professional mobile mechanic services across Gold Coast. We come to you for car servicing, diagnostics, repairs and pre-purchase inspections.",
  "url": "https://www.carguroo.com.au",
  "logo": "https://www.carguroo.com.au/src/assets/carguroo-logo-main.png",
  "image": "https://www.carguroo.com.au/og-image.jpg",
  "telephone": "+61440134765",
  "email": "info@carguroo.com.au",
  "address": {
    "@type": "PostalAddress",
    "addressRegion": "Queensland",
    "addressCountry": "AU",
    "addressLocality": "Gold Coast"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": -28.0167,
    "longitude": 153.4000
  },
  "areaServed": {
    "@type": "City",
    "name": "Gold Coast",
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "Queensland",
      "addressCountry": "AU"
    }
  },
  "openingHours": [
    "Mo-Fr 07:00-18:00",
    "Sa 08:00-16:00"
  ],
  "priceRange": "$$",
  "currenciesAccepted": "AUD",
  "paymentAccepted": "Cash, Credit Card, Bank Transfer",
  "serviceArea": {
    "@type": "GeoCircle",
    "geoMidpoint": {
      "@type": "GeoCoordinates",
      "latitude": -28.0167,
      "longitude": 153.4000
    },
    "geoRadius": "50000"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mobile Mechanic Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Pre-Purchase Vehicle Inspection",
          "description": "Comprehensive vehicle inspection before purchase with detailed reports"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Mobile Car Servicing",
          "description": "Complete car servicing at your location with quality oils and genuine parts"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Vehicle Diagnostics",
          "description": "Professional diagnostic services using modern equipment"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Mobile Auto Repairs",
          "description": "On-site automotive repairs including brakes, battery replacement and more"
        }
      }
    ]
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "sameAs": [
    "https://www.facebook.com/carguroo",
    "https://www.instagram.com/carguroo",
    "https://www.youtube.com/carguroo"
  ]
};

export const breadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const serviceSchema = (serviceName: string, description: string, url: string) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": serviceName,
  "description": description,
  "url": url,
  "provider": organizationSchema,
  "areaServed": {
    "@type": "City",
    "name": "Gold Coast",
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "Queensland",
      "addressCountry": "AU"
    }
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": serviceName,
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": serviceName,
          "description": description
        },
        "priceRange": "$$",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
});

export const faqSchema = (faqs: Array<{ question: string; answer: string }>) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Carguroo Mobile Mechanics",
  "description": "Gold Coast's premier mobile mechanic service. Professional automotive repairs and maintenance delivered to your location.",
  "url": "https://www.carguroo.com.au",
  "telephone": "+61440134765",
  "email": "info@carguroo.com.au",
  "address": {
    "@type": "PostalAddress",
    "addressRegion": "Queensland",
    "addressCountry": "AU",
    "addressLocality": "Gold Coast"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": -28.0167,
    "longitude": 153.4000
  },
  "openingHours": [
    "Mo-Fr 07:00-18:00",
    "Sa 08:00-16:00"
  ],
  "image": "https://www.carguroo.com.au/og-image.jpg",
  "priceRange": "$$"
};